var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 30",
    style: {
      enableBackground: "new 0 0 250 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#FFFFFF;stroke-miterlimit:2.6131;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#EC008C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "223.9,14 214.7,24 223.3,24 228,18.5 232.8,24 241.4,24 232.2,14 239.8,5.5 231.3,5.5 228,9.4  224.7,5.5 216.4,5.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.6,10.6c2.7,0,4.2,1.9,4.2,4.2c0,2.3-1.5,4.1-4.2,4.1c-2.7,0-4.2-1.8-4.2-4.1 C202.4,12.5,203.9,10.6,206.6,10.6L206.6,10.6z M206.6,4.9c-5.9,0-11.1,3.6-11.1,9.9c0,6.3,5.2,9.8,11.1,9.8 c5.9,0,11.1-3.6,11.1-9.8C217.7,8.5,212.5,4.9,206.6,4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.6,4.8h0.5c1.9,0,4.1,0.1,4.1,2.3c0,2-1.9,2.3-3.8,2.3h-0.8V4.8L180.6,4.8z M184.4,24c5,0,9.8-1.7,9.8-6.7 c0-3.3-1.7-5.7-5.5-6.1v-0.1c2.2-1,3-2.7,3-4.9c0-4.6-3.2-6.2-8.1-6.2h-10.1v24H184.4L184.4,24z M180.6,14.1h0.7 c2.3,0,5.8-0.3,5.8,2.6c0,2.6-3.5,2.5-5.6,2.5h-0.9V14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.4,5.5h-6.5V24h6.5v-7.4c0-3.2,0.9-5.6,4.5-5.6c1,0,1.9,0.1,2.8,0.6V5.3h-1.3c-2.6,0-4.7,1-6,3.3h-0.1V5.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.8,15.2c0-6.3-3.7-10.3-10.1-10.3c-6,0-10.2,3.7-10.2,9.9c0,6.4,4.6,9.8,10.7,9.8c2.1,0,4.2-0.5,5.9-1.5 c1.7-1,3-2.6,3.5-4.8h-6.3c-0.7,1.2-1.7,1.7-3.1,1.7c-2.7,0-4.1-1.4-4.1-4.1h13.8V15.2L149.8,15.2z M136.2,12.1 c0.4-1.9,2-2.9,3.9-2.9c1.8,0,3.4,1.2,3.7,2.9H136.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 0,
    className: "st0",
    width: 6.5,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114,6.6V24h6.5V6.6c-0.8,0.9-2,1.5-3.3,1.5C116,8.1,114.8,7.5,114,6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.6,5.5h-6.5v1.8c-1.4-1.6-3.6-2.4-5.7-2.4c-5.5,0-9.2,4.5-9.2,9.8c0,5.3,3.9,9.9,9.3,9.9 c2.2,0,4.4-0.8,5.6-2.7h0.1V24h6.5V5.5L112.6,5.5z M102.1,10.6c2.7,0,4.2,1.9,4.2,4.2c0,2.3-1.5,4.1-4.2,4.1 c-2.7,0-4.2-1.8-4.2-4.1C97.9,12.5,99.4,10.6,102.1,10.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "64.1,24 71.1,24 71.1,8.4 71.2,8.4 75.1,24 77.9,24 82.3,8.4 82.4,8.4 82.3,24 89.4,24 89.4,0 78.8,0  76.6,11.4 73.8,0 64.1,0  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.6,15.2c0-6.3-3.7-10.3-10.1-10.3c-6,0-10.2,3.7-10.2,9.9c0,6.4,4.6,9.8,10.7,9.8c2.1,0,4.2-0.5,5.9-1.5 c1.7-1,3-2.6,3.5-4.8H48c-0.7,1.2-1.7,1.7-3.1,1.7c-2.7,0-4.1-1.4-4.1-4.1h13.8V15.2L54.6,15.2z M40.9,12.1c0.4-1.9,2-2.9,3.9-2.9 c1.8,0,3.4,1.2,3.7,2.9H40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,0v24h6.5v-9.5c0-2.2,0.8-4.4,3.4-4.4c2.6,0,3,2.2,3,4.4V24h6.5V12.7c0-4.7-2.3-7.8-6.9-7.8 c-2.6,0-4.4,0.9-5.9,3h-0.1V0H13.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9,10.9 12.7,10.9 12.7,5.5 9,5.5 9,0 2.4,0 2.4,2 2.4,5.5 2.4,10.9 2.4,18.1 2.4,24 9,24  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M117.3,0c-2,0-3.7,1.7-3.7,3.7s1.7,3.7,3.7,3.7c2,0,3.7-1.7,3.7-3.7S119.3,0,117.3,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M198.8,24.7c4.8,4.5,10,4.4,15.6,0C208.9,27.4,203.7,27.6,198.8,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.4,18.8c-1.4,0-2.6,1.2-2.6,2.6s1.2,2.6,2.6,2.6c1.4,0,2.6-1.2,2.6-2.6S246.9,18.8,245.4,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.8,28.3h50.6c0.5,0,0.8,0.4,0.8,0.8v0c0,0.5-0.4,0.8-0.8,0.8H2.8C2.3,30,2,29.6,2,29.2v0 C2,28.7,2.3,28.3,2.8,28.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.c617c74b09835a9896ca24f151851955.svg";
export { ForwardRef as ReactComponent };